import { Box, IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as AccessibilityIcon } from 'assets/icons/accessibility.svg';
import { ACCESSIBILITY_CHECKER_OPENED, NAV_BAR } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { useAppDispatch } from 'modules/Editor/store';
import { setAccessibilityViewIndex } from 'modules/Editor/store/editorSettingsSlice';
import { ReactElement, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { AccessibilityViewIndex } from 'types/accessibilityViewIndex';

export const AccessibilityButton = memo((): ReactElement => {
  const { t } = useTranslation('common_navbar', { useSuspense: false, keyPrefix: 'navbar' });
  const dispatch = useAppDispatch();

  const onClick = () => {
    dispatch(setAccessibilityViewIndex(AccessibilityViewIndex.CHECK));

    Mixpanel.track(ACCESSIBILITY_CHECKER_OPENED, {
      from: NAV_BAR,
    });
  };

  return (
    <Box>
      <Tooltip label={t('accessibility-tooltip')} placement='bottom' hasArrow>
        <IconButton
          icon={<AccessibilityIcon color='black' width='20' height='20' />}
          aria-label='Open Accessibility Menu'
          onClick={onClick}
          size='sm'
          variant='ghost'
          data-testid='navbar-accessibility-button'
        />
      </Tooltip>
    </Box>
  );
});

AccessibilityButton.displayName = 'AccessibilityButton';
